module.exports = __webpack_public_path__ + "img/sy.9b5bb2de.svg";